/* eslint-disable max-len */
import React, { useState, useEffect, useRef } from 'react'

const ToolTip = ({ accessingPoint, toolTipBody, toolTipStyle, toolTipWidth, onOpenCallBack = () => { } }) => {
  const toolTipref = useRef()
  const [isOpenToolTip, setOpenToolTip] = useState(false)
  useOnClickOutside(toolTipref, () => setOpenToolTip(false))
  function useOnClickOutside(ref, handler) {
    useEffect(() => {
      const listener = event => {
        if (!ref.current || ref.current.contains(event.target)) {
          return
        }
        handler(event)
      }
      document.addEventListener('mousedown', listener)
      document.addEventListener('touchstart', listener)
      return () => {
        document.removeEventListener('mousedown', listener)
        document.removeEventListener('touchstart', listener)
      }
    }, [ref, handler])
  }

  return (
    <div className="p-relative">
      <div
        onClick={() => {
          onOpenCallBack()
          setOpenToolTip(!isOpenToolTip)
        }}
      >
        {accessingPoint}
      </div>
      <If condition={isOpenToolTip && toolTipBody}>
        <div ref={toolTipref} className={`p-absolute bg-neutral-600 ${toolTipStyle || 'tool-tip'} ${toolTipWidth || 'w-400'} zIndex`}>
          {toolTipBody}
        </div>
      </If>
    </div>
  )
}

export default ToolTip
